<template>
<div class="vliveAdvEdit form dialog-form">
    <el-dialog :title="flag=='add'?'新增广告':'编辑广告'" :visible.sync="dialogVisible">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
            <el-form-item label="" class="upload-image" prop="coverPicture">
                <upload class="sponsor-logo" :imgRule="imgRule" ref="upload" @setImage="setImage" :uploadType="uploadType"></upload>
                <!-- <div class="upload sponsor-logo" @click="openLocalGallery">
                    <div class="avatar-uploader">
                        <div tabindex="0" class="el-upload el-upload--text">
                            <i class="el-icon-plus avatar-uploader-icon icon_default_image" v-if="!item.coverPicture.furl"></i>
                            <img :src="item.coverPicture.furl+'?'+timestamp" alt="" class="avatar" v-if="item.coverPicture.furl">
                        </div>
                    </div>
                </div> -->
                <div class="el-upload__tip">建议像素：240（宽）*40（高）或者等比例，JPG、PNG格式，大小不超过5M。</div>
            </el-form-item>
            <el-form-item label="" prop="redirecturl">
                <el-input v-model.trim="item.redirecturl" placeholder="请输入网址" clearable></el-input>
                <div class="el-upload__tip">链接地址 例如：http://www.baidu.com（ 必须以http://或https://开头 ）</div>
            </el-form-item>
            <el-form-item class="form-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <!-- <localCropper :cropperOption="cropperOption" ref="localCropper" @setImage="setImage" :uploadType="uploadType"></localCropper> -->
</div>
</template>

<script>
//20210525改成直接上传图片不做裁减
import Upload from 'base/upload/upload'
import {getVliveAdvView} from 'api/api'
// import LocalCropper from 'base/cropper/localCropper'
import {mapActions} from 'vuex'
import {vliveMsg} from 'api/message'
export default {
    name: 'vliveAdvEdit',
    data() {
        let validateCoverPicture = (rule, value, callback) => {
            if (!value.furl) {
                callback(new Error('请选择视频封面'))
            } else {
                callback()
            }
        }
        return {
            timestamp: new Date().getTime(),
            cropperOption: {
                fixedNumber: [240, 40], // 截图框的宽高比例
                enlarge: 0.5, // 图片根据截图框输出比例倍数
                autoCropWidth: 240, // 默认生成截图框宽度
                autoCropHeight: 40 // 默认生成截图框高度
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            dialogVisible: false,
            flag: '',
            index: null,
            item: {
                innerid: '',
                coverPicture: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                },
                redirecturl: ''
            },
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 5,
                width: '',
                height: ''
            },
            rules: {
                coverPicture: [
                    {validator: validateCoverPicture, trigger: 'blur'}
                ],
                redirecturl: [
                    {required: true, message: '请输入网址', trigger: 'blur'},
                    // {pattern: /^http[s]?:\/\/([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/, message: '必须以http://或https://开头', trigger: 'blur'}
                    {pattern: /^http[s]?:\/\/[^\s]*$/, message: '必须以http://或https://开头', trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
    },
    methods: {
        openLocalGallery() {
            this.$refs.localCropper.openDialog()
        },
        setImage(file) {
            this.timestamp = new Date().getTime()
            this.item.coverPicture = file
        },
        openDialog(row) {
            this.dialogVisible = true
            this.$nextTick(() => {
                this.$refs.ruleForm.resetFields()
            })
            // this.$refs.localCropper.initUploadParam()
            if (row === 'add') {
                this.flag = row
                this.item = {
                    coverPicture: {
                        bucket: '',
                        fname: '',
                        fsize: '',
                        width: '',
                        height: '',
                        key: '',
                        mimeType: '',
                        objecttype: '',
                        furl: ''
                    },
                    redirecturl: ''
                }
            } else {
                console.log(row)
                this.flag = 'edit'
                this.$nextTick(() => {
                    this.$refs.upload.setImage(row.logourl+'?time=' + (new Date().getTime()))
                    this.item.innerid = row.innerid
                    this.item.redirecturl = row.redirecturl
                    this.item.coverPicture = {
                        bucket: '',
                        fname: '',
                        fsize: '',
                        width: '',
                        height: '',
                        key: row.logoattid,
                        mimeType: '',
                        objecttype: '',
                        furl: row.logourl
                    }
                })
                // this._getView(row)
            }
        },
        cancel() {

            this.$confirm(vliveMsg.cancelVliveAdv.msg, vliveMsg.cancelVliveAdv.title, {
                confirmButtonText: vliveMsg.cancelVliveAdv.confirmText,
                cancelButtonText: vliveMsg.cancelVliveAdv.cancelText
            }).then(() => {
                this._cancel()
            })
        },
        _cancel() {
            this.$refs.ruleForm.resetFields()
            this.dialogVisible = false
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm(vliveMsg.submitVliveAdv.msg, vliveMsg.submitVliveAdv.title, {
                        confirmButtonText: vliveMsg.submitVliveAdv.confirmText,
                        cancelButtonText: vliveMsg.submitVliveAdv.cancelText
                    }).then(() => {
                        if (this.flag === 'add') {
                            this.$emit('addAdv', this.item)
                        } else {
                            this.$emit('editAdv', this.item)
                        }
                        this._cancel()
                    })
                }
            })
        },
        _getView(row) {
            this.setLoading(true)
            getVliveAdvView({
                data: {
                    innerid: row.innerid
                },
                success: data => {
                    this.item.coverPicture = data.data.logoPic
                    this.item.redirecturl = data.data.redirecturl
                    this.item.innerid = data.data.innerid
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setVliveModelAdv',
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        // LocalCropper
        Upload
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveAdvEdit {
    .upload-image{
        .el-form-item__content{
        }
        .sponsor-logo{
            margin-right: 20px;
        }
        .avatar-uploader{
            box-sizing: border-box;
            width: 300px;
            height: 40px;
        }
        .el-upload__tip{
            align-self: flex-end;
        }
    }
}
</style>
